import React, { FunctionComponent, ReactNode, SyntheticEvent } from 'react'
import clsx from 'clsx'

import { ButtonTypes } from './Button'
import styles from './style.module.scss'

export interface ShellButtonProps extends Omit<React.AnchorHTMLAttributes<HTMLButtonElement>, 'onClick'> {
  children: ReactNode
  disabled?: boolean
  onClick?: (e: SyntheticEvent) => void
  tabIndex?: number
  testNameSpace?: string
  type?: ButtonTypes
  'aria-disabled'?: boolean | 'true' | 'false'
  'aria-label'?: string
  'aria-labelledby'?: string
}
export type ShellButtonComponent = FunctionComponent<ShellButtonProps>

export const ShellButton: ShellButtonComponent = ({
  children,
  disabled = false,
  onClick = () => {},
  tabIndex = 0,
  type = 'button',
  testNameSpace = '',
  className = '',
  ...otherProps
}) => {
  const buttonClassNames = clsx(styles.shellButton, disabled && styles.disabled, className)

  return (
    <button
      className={buttonClassNames}
      disabled={disabled}
      onClick={onClick}
      tabIndex={tabIndex}
      type={type}
      {...(testNameSpace.length > 0 && { 'data-testid': `${testNameSpace}-shellButton` })}
      {...(disabled && { 'aria-disabled': true })}
      {...otherProps}
    >
      {children}
    </button>
  )
}
